import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'offlineFirst',
      refetchOnWindowFocus: false
    },
    mutations: {
      networkMode: 'offlineFirst'
    }
  }
})

export default queryClient
